import { IComponent } from '@faire/web-api--source/indigofair/data/IComponent';

export namespace IColumnSection {
  /**
   * Return an instance of IColumnSection with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IColumnSection>): IColumnSection =>
    ({
      components: [],
      ...(partial ?? {}),
    }) as IColumnSection;
}

/**
 * A simple section representing a vertically stacked list of components
 * DEPRECATED, please use a LayoutSection with a FlowLayout that specifies
 * 100% for all component widths instead.
 */
export interface IColumnSection {
  /**
   * The components to be rendered within the section
   */
  components: Array<IComponent>;
}
